import { Input, Directive } from "@angular/core"

@Directive()
export class GTMComponent {
    @Input() public gtmPrefix?: string = "gtm"
}
